(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlCertificationFullReviewController', Controller);

    Controller.$inject = ['$scope', '$state', '$mdToast', 'commonAricService'];

    function Controller($scope, $state, $mdToast, commonAricService) {

        // Results
        $scope.results = [{
            model: 'IsControlDescriptionAccurate',
            templateUrl: require('./grcControlCertification.full.review.IsAccurate.tpl.html'),
        }, {
            model: 'ControlPerformance',
            templateUrl: require('./grcControlCertification.full.review.Performance.tpl.html'),
        }, {
            model: 'CertificationComment',
            templateUrl: require('./grcControlCertification.full.review.Comment.tpl.html'),
        }];

        // Show Collapsed?
        $scope.showCollapsed = function () {
            if ($scope.boxModel.ControlAssessment.IsCertifying) return true;

            if ($scope.boxModel.ControlAssessment.IsCertificationToReview) return false;

            if (!$scope.boxContext) return;

            return $scope.boxContext.showCollapsed;
        };

        // Show Actions
        $scope.showActions = function () {
            if (!$scope.boxModel.ControlAssessment.GovernanceProcess.IsActive) return false;

            return $scope.boxModel.ControlAssessment.IsCertificationToReview;
        };

        // Review Certification
        $scope.reviewCertification = function () {
            commonAricService
                .reviewCertification($scope.boxModel.ControlAssessment.ControlID)
                .then(function () {

                    $mdToast.show(
                         $mdToast
                             .simple()
                             .content('Certification has been reviewed')
                             .position('top right')
                             .hideDelay($scope.govNotificationDelay)
                             .action('OK')
                             .theme('primary')
                    );

                    $state.reload();
                });
        }
    }
})();
